import { Component, OnInit,ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';//para pasar datos de regreso desde aca del modal
import * as firebase from 'firebase'

@Component({
  selector: 'app-modal-herramientas-ycontroles',
  templateUrl: './modal-herramientas-ycontroles.component.html',
  styleUrls: ['./modal-herramientas-ycontroles.component.scss']
})
export class ModalHerramientasYControlesComponent implements OnInit {
  modal;
  actividad;
  indiceActividad;
  trabajador;
  indiceTrabajador;
  arrayDeEmpleados;


  herramientasYControlesTrabajoEnAlturas = {
    herramientas: { arneses: 0, andamios: 0, eslingas: 0, eslingaDePosicionamiento: 0, cascos: 0, tieOff: 0, poleas: 0, descendedor: 0, gibbs: 0, lineaDeVida: 0, arrestador: 0, mosquetones: 0, cuerdas: 0, escaleras: 0, cintaDeAnclaje: 0, pertiga: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesTrabajoEnCaliente = {
    herramientas: { pulidoras: 0, motosoldadores: 0, esmeriles: 0, plantasElectricas: 0, taladrosPercutores: 0, sierras: 0, motosierras: 0, guadanas: 0, otrosChispas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesLevantamientoMecanico = {
    herramientas: { grua: 0, camionBrazoGrua: 0, montacargas: 0, telehandlers: 0, aparejos: 0, gibbs: 0, arrestadores: 0, mosquetones: 0, cuerdas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEnergiasPeligrosas = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEspaciosConfinados = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesHazmat = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesSupervicionYmonitoreo = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesOtros = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 


  constructor(public activeModal: NgbActiveModal) {
   }

  ngOnInit(): void {
    this.modal=this.activeModal

      if(this.actividad.actividad == 'TRABAJO EN ALTURAS' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
          this.herramientasYControlesTrabajoEnAlturas = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'TRABAJO EN CALIENTE' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesTrabajoEnCaliente = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'LEVANTAMIENTO MECÁNICO' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesLevantamientoMecanico = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'ENERGÍAS PELIGROSAS' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesEnergiasPeligrosas = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'ESPACIOS CONFINADOS' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesEspaciosConfinados = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'HAZMAT' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesHazmat = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'SUPERVISIÓN Y MONITOREO' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesSupervicionYmonitoreo = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }else
      if(this.actividad.actividad == 'OTROS' && this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles != undefined){
        this.herramientasYControlesOtros = this.arrayDeEmpleados[this.indiceTrabajador].arraydeactividades[this.indiceActividad].herramientasYcontroles
      }
      
    
  }

}
